export const VISA_BULLETIN_TYPE_MAP = {
  'this-month': 'this-month',
  'next-month': 'next-month',
} as const

export const VISA_BULLETIN_TABS = [
  {
    label: 'This Month',
    value: VISA_BULLETIN_TYPE_MAP['this-month'],
  },
  {
    label: 'Next Month',
    value: VISA_BULLETIN_TYPE_MAP['next-month'],
  },
] as const
